import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, LifeBuoy } from "lucide-react";
import { Logo } from "../brand/Logo";
import { ColorBand } from "../brand/ColorBand";
import { THEMES, CONTACT } from "../../data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-white relative overflow-hidden">
    <ColorBand height={6} />
    <div className="mx-auto max-w-7xl px-5 lg:px-8 py-16 grid gap-12 md:grid-cols-12">
      <div className="md:col-span-4 space-y-5">
        <Logo theme="#45ADE0" />
        <p className="text-white/60 text-sm max-w-xs leading-relaxed">
          Votre partenaire informatique et télécom à Nouméa. Un seul interlocuteur pour tout votre système d'information.
        </p>
        <Link to="/support" data-testid="footer-support-link" className="btn-ghost-light inline-flex">
          <LifeBuoy size={16} /> Accès assistance
        </Link>
      </div>
      <div className="md:col-span-3">
        <h4 className="footer-title">Nos métiers</h4>
        <ul className="space-y-2.5">
          {THEMES.map((t) => (
            <li key={t.slug}>
              <Link to={`/services/${t.slug}`} data-testid={`footer-service-${t.slug}`} className="text-sm text-white/70 hover:text-white flex items-center gap-2 transition-colors">
                <span className="h-2 w-2" style={{ background: t.color }} /> {t.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-3">
        <h4 className="footer-title">Nous joindre</h4>
        <ul className="space-y-3 text-sm text-white/70">
          <li className="flex gap-2"><Phone size={16} className="mt-0.5 shrink-0" /><span>Support : <a href={CONTACT.hotlineHref} data-testid="footer-support-phone" className="hover:text-white whitespace-nowrap">{CONTACT.hotline}</a></span></li>
          <li className="flex gap-2"><Phone size={16} className="mt-0.5 shrink-0" /><span>Commercial & administratif : <a href={CONTACT.phoneHref} data-testid="footer-sales-phone" className="hover:text-white whitespace-nowrap">{CONTACT.phone}</a></span></li>
          <li className="flex gap-2"><Mail size={16} className="mt-0.5 shrink-0" /><a href={`mailto:${CONTACT.email}`} className="hover:text-white">{CONTACT.email}</a></li>
          <li className="flex gap-2"><LifeBuoy size={16} className="mt-0.5 shrink-0" /><a href={`mailto:${CONTACT.supportEmail}`} data-testid="footer-support-email" className="hover:text-white">{CONTACT.supportEmail}</a></li>
          <li className="flex gap-2"><MapPin size={16} className="mt-0.5 shrink-0" /><span>{CONTACT.address}<br />{CONTACT.city}</span></li>
        </ul>
      </div>
      <div className="md:col-span-2">
        <h4 className="footer-title">Horaires</h4>
        <ul className="space-y-2 text-xs text-white/60">
          {CONTACT.hours.map(([d, h]) => (
            <li key={d}><span className="text-white/85 block">{d}</span>{h}</li>
          ))}
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-5 flex flex-wrap gap-4 justify-between text-xs text-white/40">
        <span>© {new Date().getFullYear()} ENOVA · Nouméa, Nouvelle-Calédonie</span>
        <div className="flex gap-5">
          <Link to="/mentions-legales" data-testid="footer-legal-link" className="hover:text-white">Mentions légales</Link>
        </div>
      </div>
    </div>
  </footer>
);
